<!-- Two labelled inputs side by side, of equal width, inside a "down" EditLayer: the affiliation and country
     (ProfileMeta), the first and last name (Name.vue). Enter commits (the dialog's OK); Tab in the
     second input emits "tab" (e.g. on to the next field). -->

<template>
  <label class="layer-column">
    <span class="layer-label">{{ labels[0] }}</span>
    <input
      ref="firstInputRef"
      v-model="first"
      class="layer-input"
      type="text"
      :maxlength="maxLength"
      :autocomplete="autocomplete[0]"
      @keydown.enter.prevent="$emit('commit')"
    />
  </label>
  <label class="layer-column">
    <span class="layer-label">{{ labels[1] }}</span>
    <input
      v-model="second"
      class="layer-input"
      type="text"
      :maxlength="maxLength"
      :autocomplete="autocomplete[1]"
      @keydown.enter.prevent="$emit('commit')"
      @keydown.tab.exact.prevent="$emit('tab')"
    />
  </label>
</template>

<script setup>
import {ref} from "vue";

defineProps({
  labels: {type: Array, required: true},
  autocomplete: {type: Array, default: () => ["off", "off"]},
  maxLength: {type: Number, default: undefined} // both inputs; none by default
});
defineEmits(["commit", "tab"]);
const first = defineModel("first", {type: String, default: ""});
const second = defineModel("second", {type: String, default: ""});
const firstInputRef = ref(null);

// no scroll: mid-transition the input is still outside the layer, and scrolling it into view
// shifted the whole dialog sideways (ProfileMeta)
function focus() {
  firstInputRef.value?.focus({preventScroll: true});
}

defineExpose({focus});
</script>

<style scoped>
.layer-column {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.layer-label {
  font-size: 12px;
  font-weight: 400; /* not the row's (the name is 800) */
  text-align: left; /* not the centred header's */
  line-height: 15px;
  color: white;
  user-select: none;
}
/* the only white surfaces: plain rectangles inside the dark layer */
.layer-input {
  width: 100%;
  height: 24px;
  margin: 0;
  padding: 0 8px;
  box-sizing: border-box;
  border: none;
  border-radius: 0;
  outline: none;
  background: white;
  font: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.75);
  user-select: text; /* the rows around it are unselectable while editing */
}
.layer-input:focus {
  box-shadow: inset 0 0 0 2px var(--brand-color);
}
</style>
